import OPTS from './options';

function removeDataFromeStorage() {
    sessionStorage.removeItem('s-all');
    sessionStorage.removeItem('s-fund');
    sessionStorage.removeItem('s-percorso');
    sessionStorage.removeItem('s-raccolta');
    sessionStorage.removeItem('url-search');
}

function initSessionStorage() {
    if(!OPTS.storage_enabled)
        return;

    const searchUrl = sessionStorage.getItem('url-search');
    if (searchUrl !== window.location.href)
        removeDataFromeStorage();

    sessionStorage.setItem('url-search', window.location.href);
}

export function getStoredData() {
    if(!OPTS.storage_enabled)
        return null;

    initSessionStorage();

    const storage = window.sessionStorage;
    const item = storage.getItem(OPTS.storage_id);

    return item ? JSON.parse(item) : null;
}

export function storeData(data) {
    if(!OPTS.storage_supported || !OPTS.storage_id)
        return;

    const storage = window.sessionStorage;
    storage.setItem(OPTS.storage_id, JSON.stringify(data));
}
